/**
 * Import
 * - Libraries
 */
import * as React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../store'

/**
 * Import
 * - Selectors
 */
import { getUserSessionState } from '../selectors/user'

const mapStateToProps = (state: RootState) => {
    return {
        userSession: getUserSessionState(state),
    }
}

class AdminValidator extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
    }

    render() {

        return (!this.props.userSession.agentAdmin) ? <Redirect to="/dashboard/" /> : null

    }
}

export default connect(mapStateToProps)(AdminValidator)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/AdminValidator.tsx